// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface IowaVariationDTO extends EntitySelectorDTO { 
	id: number;
	order: number;
	code: string | null;
	name: string | null;
	specialUse: boolean;
	display: string | null;
}

const IowaVariationDTO = {
    className: 'IowaVariationDTO',
    create: (initValues?: Partial<IowaVariationDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			order: 0,
			code: "",
			name: "",
			specialUse: false,
			display: "",
        },
        initValues);
    },
	id: 'id',
	order: 'order',
	code: 'code',
	name: 'name',
	specialUse: 'specialUse',
	display: 'display',
};

export default IowaVariationDTO;